import React from 'react';

import memoize from 'memoize-one';
import Timestamp from "react-timestamp";

import {
  Button
} from 'reactstrap';
const customStyles = {





  
  rows: {
    style: {
      border:'0.5px solid rgb(130, 190, 80)',
    }
  },
  headCells: {
    style: {
      // override the cell padding for head cells
backgroundColor:'#CDCDCD',
paddingTop:'20px',
paddingBottom:'20px',

    },
  },
  table: {
    style: {
    },

    
  },


  cells: {
    style: {
      
    },

    
  },


  
};






const columnsForSAP = memoize((clickHandler, omits) => [

  {
    name: 'ID',
    selector: 'id',
    sortable: true,
    center: true,
    

  },
  {
    name: 'Action',

    cell:(row) => <Button onClick={clickHandler} style={{backgroundColor:'rgb(130, 190, 80)'}}  id={row.id}>View/Edit</Button>,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },

  {
    name: 'Queue',
    selector: 'queue',
    sortable: true,
    omit:true,

  },


  {
    name: 'Agent',
    selector: 'agent',
    sortable: true,
    wrap:!omits,
    grow: 2


  },
  {
    name: 'Category',
    selector: 'category',
    sortable: true,
    wrap:true,


  },
  {
    name: 'Sub-Category',
    selector: 'sub',
    sortable: true,
    omit:omits,
    wrap:true,
    grow: 2

  },

  {
    name: 'description',
    selector: 'description',
omit:true,

  },

  {
    name: 'State',
    selector: 'state',
    sortable: true,

  },
  {
    name: 'Response SLA',
    selector: 'slares',
    sortable: true,

  },
  {
    name: 'iP Address',
    selector: 'ipadd',
    sortable: true,
    wrap:!omits,
    width:"120px",
    grow: 3

  } ,
 
  {
    name: 'Client',
    selector: 'client',
    sortable: true,
   wrap:true,
   grow: 2


  },
  {
    name: 'Request#',
    selector: 'sapreqnum',
    sortable: true,
    omit:omits,

    width:"100px"

  },

  {
    name: 'Site',
    selector: 'site',
    sortable: true,
    width:"100px"

  },
  {
    name: 'Department',
    selector: 'department',
    sortable: true,
    omit:true,

  }
  
  ,

  {
    name: 'Open Time',
    cell:(row) => <Timestamp relative date={row.createdAt} autoUpdate />,

    sortable: true,
    grow: 2

  },
  {
    name: 'Last Update',
    cell:(row) => <Timestamp relative date={row.updatedAt}  autoUpdate />,
    sortable: true,
    omit:omits,
    grow: 2

  },






]);








const columns = memoize((clickHandler, omits , isall ) => [

  {
    name: 'ID',
    selector: 'id',
    sortable: true,
    center: true,
    
    

  },


  {
    name: 'Queue',
    selector: 'queue',
    sortable: true,
    omit:!isall,

  },


  {
    name: 'Action',

    cell:(row) => <Button onClick={clickHandler} style={{backgroundColor:'rgb(130, 190, 80)'}}  id={row.id}>View/Edit</Button>,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },




  {
    name: 'Agent',
    selector: 'agent',
    sortable: true,
    wrap:!omits,
    grow: 2


  },
  {
    name: 'Category',
    selector: 'category',
    sortable: true,
    wrap:true, 
    grow: 2


  },
  {
    name: 'Sub-Category',
    selector: 'sub',
    sortable: true,
    omit:omits,
    wrap:true,
    grow: 2

  },

  {
    name: 'description',
    selector: 'description',
omit:true,

  },

  {
    name: 'State',
    selector: 'state',
    sortable: true,
    center: true,

  },
  {
    name: 'Response SLA',
    selector: 'slares',
    sortable: true,

  },
  {
    name: 'iP Address',
    selector: 'ipadd',
    sortable: true,
    wrap:true,
    grow: 3

  } ,
 
  {
    name: 'Client',
    selector: 'client',
    sortable: true,
   wrap:true,
   grow: 2



  },
  {
    name: 'Site',
    selector: 'site',
    sortable: true,
    width:"100px"

  },
  {
    name: 'Department',
    selector: 'department',
    sortable: true,
    omit:true,

  }
  
  ,

  {
    name: 'Open Time',
    cell:(row) => <Timestamp relative date={row.createdAt} autoUpdate />,

    sortable: true,
    grow: 2

  },
  {
    name: 'Last Update',
    cell:(row) => <Timestamp relative date={row.updatedAt}  autoUpdate />,
    sortable: true,
    omit:omits,
    grow: 2

  },






]);





const endusercolumns = memoize((clickHandler) => [

  {
    name: 'ID',
    selector: 'id',
    sortable: true,
    center: true,
    

  },
  {
    name: 'Action',

    cell:(row) => <Button onClick={clickHandler} style={{backgroundColor:'rgb(130, 190, 80)'}}  id={row.id}>View</Button>,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },

  {
    name: 'Queue',
    selector: 'queue',
    sortable: true,

  },


  {
    name: 'Agent',
    selector: 'agent',
    sortable: true,
    wrap:true

  },
  {
    name: 'Category',
    selector: 'category',
    sortable: true,
    wrap:true

  },
  {
    name: 'Sub-Category',
    selector: 'sub',
    sortable: true,
    wrap:true
  },



  {
    name: 'State',
    selector: 'state',
    sortable: true,
    center: true,

  },


 

  {
    name: 'Location',
    selector: 'site',
    sortable: true,

  },

  
  ,

  {
    name: 'Open Time',
    cell:(row) => <Timestamp relative date={row.createdAt} autoUpdate />,

    sortable: true,

  },
  {
    name: 'Last Update',
    cell:(row) => <Timestamp relative date={row.updatedAt}  autoUpdate />,
    sortable: true,

  },






]);









export { columnsForSAP, columns, endusercolumns, customStyles };
